import React from "react";
import moment from "moment";
import { CloseIcon, Dialog, Flex, Text } from "@fluentui/react-northstar";
import { Clock16Regular } from "@fluentui/react-icons";

import { Column, Event, Row, TypeLeaveText, Wrapper } from "../../styles";
import { COLUMN_WIDTH } from "../../constants";
import DialogLeaveDetail from "../Dialogs/DialogLeaveDetail";
import { useQueryClient } from "react-query";
import { useState } from "react";
import ContentTimeLineCollegueInfo from "../../../../features/leave/components/TimeLineCollab/ContentTimeLineCollegueInfo";
import { DEVICE } from "../../../../constants/responsive";
import styled from "styled-components";

const calculateDimensions = ({
    row,
    calendar,
    column_length,
    eventIndex = 0,
    totalEventsForDay = 1,
}) => {
    const event_month = moment(row.start_date).get("month") + 1;

    const start_day =
        event_month !== calendar.month + 1
            ? 0
            : moment(row.start_date).get("date") - 1;

    const end_day = moment(row.end_date).get("date");
    const startPx = start_day * COLUMN_WIDTH;
    const width = COLUMN_WIDTH * (end_day - start_day);
    const max_width = (column_length - start_day) * COLUMN_WIDTH;

    // Hauteur d'un événement + marge
    const EVENT_HEIGHT = 17; // Ajustez selon votre design
    const EVENT_MARGIN = 1; // Marge entre les événements empilés
    const BASE_ROW_HEIGHT = 35; // Hauteur de base d'une ligne

    let topOffset;
    if (totalEventsForDay === 1) {
        // Centrer l'événement unique verticalement
        topOffset = (BASE_ROW_HEIGHT - EVENT_HEIGHT) / 2;
    } else {
        // Empiler les événements multiples
        topOffset = eventIndex * (EVENT_HEIGHT + EVENT_MARGIN);
    }
    return { startPx, width, max_width, topOffset };
};

// Fonction pour grouper les événements par date
const groupEventsByDate = (events) => {
    const grouped = {};

    events.forEach((event, index) => {
        const date = event.start_date;
        if (!grouped[date]) {
            grouped[date] = [];
        }
        grouped[date].push({ ...event, originalIndex: index });
    });

    return grouped;
};

const RowsFillTimelineWithData = ({
    rowsData,
    column_length,
    weekends,
    calendar,
    setConfigToast,
}) => {
    const clientQuery = useQueryClient();
    const [openDetailEventCollegue, setOpenDetailEventColleague] =
        useState(false);
    const [detailEventCollegue, setDetailEventCollegue] = useState(null);

    const successRequest = ({ toastMessage = "", level = "success" }) => {
        setConfigToast({
            visible: true,
            content: toastMessage,
            level,
        });
        return clientQuery.refetchQueries(["timeline::collab::get"]);
    };
    const openDialog = (eventId, eventData) => {
        setOpenDetailEventColleague(eventId);
        setDetailEventCollegue(eventData);
    };
    return rowsData?.map((rows, i) => {
        if (rows.rowsCounter === null) return <Row key={i}></Row>;

        if (rows.collapsed === true)
            return (
                <Row
                    key={i}
                    initial={{ height: 35 }}
                    animate={{ height: 0 }}
                    transition={{ duration: 0.2 }}
                ></Row>
            );

        return rows?.events?.map((userEvents, rowIndex) => {
            console.log("userEvents", userEvents);
            if (!userEvents || userEvents.length === 0) {
                return (
                    <Row key={`${i}-${rowIndex}`}>
                        {new Array(column_length)
                            .fill("")
                            .map((e, colIndex) => (
                                <Column
                                    key={colIndex}
                                    isWeekend={weekends?.includes(colIndex + 1)}
                                />
                            ))}
                    </Row>
                );
            }

            // Grouper les événements par date
            const eventsByDate = groupEventsByDate(userEvents);

            return (
                <Row
                    key={rowIndex}
                    initial={{ height: 0 }}
                    animate={{ height: 35 }}
                    transition={{ duration: 0.2 }}
                    style={{ position: "relative" }}
                >
                    {new Array(column_length).fill("").map((e, i) => (
                        <Column key={i} isWeekend={weekends?.includes(i + 1)} />
                    ))}

                    {Object.entries(eventsByDate).map(
                        ([date, eventsForDate]) => {
                            return eventsForDate.map((data, eventIndex) => {
                                const { startPx, max_width, width, topOffset } =
                                    calculateDimensions({
                                        row: data,
                                        calendar,
                                        column_length,
                                        eventIndex,
                                        totalEventsForDay: eventsForDate.length,
                                    });

                                const commonWrapperProps = {
                                    startPx,
                                    width: width <= 0 ? max_width : width,
                                    color: data?.type.color,
                                    style: {
                                        position: "absolute",
                                        top: `${topOffset}px`,
                                        height: "18px",
                                    },
                                };
                                return data?.type.id < 0 ? (
                                    <DialogStyle
                                        key={`${data.id}-${eventIndex}`}
                                        open={
                                            openDetailEventCollegue === data.id
                                        }
                                        onCancel={() =>
                                            setOpenDetailEventColleague(false)
                                        }
                                        trigger={
                                            <Wrapper
                                                {...commonWrapperProps}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (data?.type.id < 0) {
                                                        openDialog(
                                                            data.id,
                                                            data
                                                        );
                                                    }
                                                }}
                                            >
                                                <Event
                                                    truncated
                                                    content={
                                                        <Flex
                                                            vAlign="center"
                                                            styles={{
                                                                border: "1px solid transparent",
                                                                width:
                                                                    width <= 0
                                                                        ? max_width +
                                                                          "px"
                                                                        : width +
                                                                          "px",
                                                                height: "18px",
                                                            }}
                                                        >
                                                            {data?.status.id ===
                                                                1 && (
                                                                <Clock16Regular />
                                                            )}
                                                            <TypeLeaveText
                                                                truncated
                                                                content={
                                                                    data.type
                                                                        .name
                                                                }
                                                            />
                                                        </Flex>
                                                    }
                                                />
                                            </Wrapper>
                                        }
                                        content={
                                            <ContentTimeLineCollegueInfo
                                                data={detailEventCollegue}
                                            />
                                        }
                                        header={
                                            !detailEventCollegue?.type
                                                ?.is_remote
                                                ? "Absence"
                                                : "Télétravail"
                                        }
                                        headerAction={{
                                            iconOnly: true,
                                            icon: <CloseIcon />,
                                            onClick: () =>
                                                setOpenDetailEventColleague(
                                                    false
                                                ),
                                        }}
                                    />
                                ) : (
                                    <DialogLeaveDetail
                                        key={`${data.id}-${eventIndex}`}
                                        leave_details={data}
                                        user_details={data?.user}
                                        content={
                                            <Wrapper {...commonWrapperProps}>
                                                <Event
                                                    truncated
                                                    content={
                                                        <Flex
                                                            vAlign="center"
                                                            styles={{
                                                                border: "1px solid transparent",
                                                                width:
                                                                    width <= 0
                                                                        ? max_width +
                                                                          "px"
                                                                        : width +
                                                                          "px",
                                                                height: "18px",
                                                            }}
                                                        >
                                                            {data?.status.id ===
                                                                1 && (
                                                                <Clock16Regular />
                                                            )}
                                                            <TypeLeaveText
                                                                truncated
                                                                content={
                                                                    data.type
                                                                        .name
                                                                }
                                                            />
                                                        </Flex>
                                                    }
                                                />
                                            </Wrapper>
                                        }
                                        cbOnApproveLeave={(data) => {
                                            const isSuccess = data?.success;
                                            successRequest({
                                                level: isSuccess
                                                    ? "success"
                                                    : "danger",
                                                toastMessage: isSuccess
                                                    ? "La demande a bien été acceptée"
                                                    : data?.message,
                                            });
                                        }}
                                        cbOnRefuseLeave={(data) => {
                                            const isSuccess = data?.success;
                                            successRequest({
                                                level: isSuccess
                                                    ? "success"
                                                    : "danger",
                                                toastMessage: isSuccess
                                                    ? "La demande a bien été refusée"
                                                    : data?.message,
                                            });
                                        }}
                                        cbOnCancelLeave={(data) => {
                                            const isSuccess = data?.success;
                                            successRequest({
                                                level: isSuccess
                                                    ? "success"
                                                    : "danger",
                                                toastMessage: isSuccess
                                                    ? "La demande a bien été Annulée"
                                                    : data?.message,
                                            });
                                        }}
                                        cbOnDeleteLeave={(data) => {
                                            const isSuccess = data?.success;
                                            successRequest({
                                                level: isSuccess
                                                    ? "success"
                                                    : "danger",
                                                toastMessage: isSuccess
                                                    ? "La demande a bien été Supprimée"
                                                    : data?.message,
                                            });
                                        }}
                                    />
                                );
                            });
                        }
                    )}
                </Row>
            );
        });
    });
};

export default RowsFillTimelineWithData;

const DialogStyle = styled(Dialog)`
    @media ${DEVICE.mobileS} {
        width: 90%;
    }
    @media ${DEVICE.laptop} {
        width: 764px;
    }
`;
